import React, { useContext } from 'react'
import { BodyContext } from '../../../contexts/BodyProvider'
import useCallRestApi from '../../../hooks/useCallRestApi'
import styles from './adminEditCategoryBI.module.css'

type Props = {
    category: CategoryBI
    handleEditCategory: (value: boolean) => void
    handleDeleteCategory: (value1: number, value2: string) => void
}
const AdminEditCategoryBI = ({category, handleEditCategory, handleDeleteCategory}: Props) => {
    const [callRestApi] = useCallRestApi();
    const { categoryBIValue } = useContext(BodyContext);
    
  const handleOpen = async (id:number) => {
    const link: ResourceLink = {
        href: `api/category_bi/${id}`,
        rel: "search",
        type: "GET",
    };
    try{
        await callRestApi<CategoryBI>({
            link,
            onSuccess: (catBI: CategoryBI) => {
                categoryBIValue?.setCategoryBI(catBI);
                handleEditCategory(true)
            },
            onError: (err: ErrorApi) => {},
            onFinally: () => {},
        });
    }catch(error){
        console.log(error)
    }
    
  };

  return (
    <div key={category.id} className={styles.item_content} style={{backgroundColor:`${category.color}`}}>
        <h5>{category.name}</h5>
        <div className={styles.item_icons}>
        <i className="bi bi-pencil-fill" style={{fontSize:'22px'}} onClick={() => handleOpen(category.id)}></i>
        <i className="bi bi-trash-fill" style={{fontSize:'22px'}} onClick={() => handleDeleteCategory(category.id, category.name)}></i>
        </div>
    </div>
  )
}

export default AdminEditCategoryBI